<template lang="pug">
  window(title="Embedded hscMap", :isOpen="module.show", :closeButton="true", @closebuttonclick="module.show = false", positionHint="center", :zGroup=1)
    table
      tr
        th Width
        td
          input(type="text", v-model.number="width")
      tr
        th Height
        td 
          input(type="text", v-model.number="height")
      tr
        th https
        td
          input(type="checkbox", v-model="https", @focus="onFocus")
    p Paste the following HTML in your HTML.
    textarea(:value="html", readonly)
</template>


<script lang="ts">
import Vue from 'vue'
import { store } from '@/store';
import { Prop, Component } from 'vue-property-decorator';
import { IframeModule } from '@/modules/IframeModule';
import { dom } from '@/utils/dom';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: IframeModule

  width = 400
  height = 400
  https = true

  get html() {
    // tslint:disable:no-unused-expression
    this.$route.query
    const baseUrl = `${this.https ? 'https' : 'http'}://hscmap.mtk.nao.ac.jp/hscMap4/app/?mode=embedded`
    const url = `${baseUrl}${location.hash}`
    return `<iframe width="${this.width}" height="${this.height}" src="${url}"></iframe>`
  }

  onFocus(e: FocusEvent) {
    const target = e.target! as HTMLTextAreaElement
    dom.pbcopy(target.value)
  }
}
</script>


<style lang="scss" scoped>
textarea {
  width: 100%;
  height: 8em;
}

th {
  text-align: right;
}

p {
  white-space: nowrap;
}
</style>